import { useState, useRef } from "react";

export const useNetworkGraphBetweennessChart = (title, configTooltip = {}) => {
    const chartRef = useRef(null);

    const [options, setOptions] = useState({
        chart: {
            type: "networkgraph",
            height: 700,
            animation: false,
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
        },
        title: {
            text: title,
            align: "center",
        },
        tooltip: configTooltip,
        plotOptions: {
            networkgraph: {
                keys: ["from", "to"],
                layoutAlgorithm: {
                    enableSimulation: false,
                    integration: "verlet",
                    approximation: "barnes-hut",
                    gravitationalConstant: 0.01,
                },
                draggable: false,
            },
            series: {
                animation: false,
                turboThreshold: 1,
            },
        },
        turboThreshold: 1,
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando...",
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        series: [
            {
                accessibility: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: true,
                    linkFormat: "",
                },
                id: "reddit-graph",
            },
        ],
        credits: { enabled: false },
    });

    const showLoading = () => chartRef.current?.showLoading();
    const hideLoading = () => chartRef.current?.hideLoading();

    const onChartReady = (chartInstance) => {
        chartRef.current = chartInstance;
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        onChartReady,
    };
};
